<template>
  <v-app>
    <navigation-drawer></navigation-drawer>
    <toolbar></toolbar>
    <v-content>
      <v-fade-transition mode="out-in">
        <router-view/>
      </v-fade-transition>
    </v-content>
    <v-footer :inset="true" app>
      <v-spacer></v-spacer>
      <span>Agilea &copy; {{(new Date()).getFullYear()}} Version 2.5.0</span>
      <v-spacer></v-spacer>
    </v-footer>
    <snack-bar></snack-bar>
  </v-app>
</template>

<script>
import NavigationDrawer from './layouts/NavigationDrawer'
import Toolbar from './layouts/Toolbar'
import SnackBar from './components/SnackBar'
export default {
  name: 'App',
  mounted() { },
  components : {
    NavigationDrawer,
    Toolbar,
    SnackBar
  }
}
</script>
<style>
html { overflow-y: auto }
.v-btn--floating .v-btn__content {
    height: initial !important;
}
</style>
